import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { interactionsAPI } from '../lib/api';

const MODULE_LABELS = {
  '/': 'Dashboard',
  '/members': 'Miembros',
  '/events': 'Eventos',
  '/announcements': 'Anuncios',
  '/posts': 'Noticias',
  '/ministries': 'Ministerios',
  '/groups': 'Grupos',
  '/courses': 'Cursos',
  '/contributions': 'Aportes',
  '/wallet': 'Wallet',
  '/prayers': 'Oraciones',
  '/petitions': 'Peticiones',
  '/mentorships': 'Mentorías',
  '/moderation': 'Moderación',
  '/analytics': 'Analíticas',
  '/team': 'Equipo',
  '/apoyo-pastoral': 'Tu Aliado Pastoral',
  '/settings': 'Configuración',
  '/subscriptions': 'Suscripciones',
  '/support': 'Soporte',
};

/** Records a view per module visited and the time spent on it. */
export function useModuleTracker(churchId, enabled) {
  const { pathname } = useLocation();
  const session = useRef(`suite-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`);
  const entered = useRef(Date.now());

  useEffect(() => {
    if (!enabled) return undefined;
    const label = MODULE_LABELS[pathname];
    if (!label) return undefined;

    entered.current = Date.now();
    interactionsAPI.track({
      entity_type: 'module',
      entity_id: pathname,
      entity_title: label,
      interaction_type: 'view',
      church_id: churchId || undefined,
      session_id: session.current,
      metadata: { source: 'suite_ministerial', screen: pathname },
    }).catch(() => {});

    return () => {
      const elapsed = Date.now() - entered.current;
      if (elapsed < 3000) return;
      interactionsAPI.track({
        entity_type: 'module',
        entity_id: pathname,
        entity_title: label,
        interaction_type: 'time_spent',
        duration_ms: Math.min(elapsed, 1800000),
        church_id: churchId || undefined,
        session_id: session.current,
        metadata: { source: 'suite_ministerial', screen: pathname },
      }).catch(() => {});
    };
  }, [pathname, churchId, enabled]);
}

export default useModuleTracker;
